import React, { useState } from 'react';
import { IAssistantMessage, IQuestionOption } from '../../../types';
import { ChatMessage } from '../../message-box';
import { SingleChoiceCard } from './SingleChoiceCard';
import { ConfirmUpdateModal } from '../../ConfirmUpdateModal';
import { AlertMessageBubble } from '../alert';

interface SelectMessageBublesProps {
    message: IAssistantMessage;
    handleSelect: (questionId: string, option: IQuestionOption) => void;
    updateSelect: (questionId: string, option: IQuestionOption) => void;
    isProcessing?: boolean;
    isEditMode?: boolean;
    alertMessage?: string | null;
    isBlending?: boolean;
}

export const SelectSingleMessageBubles: React.FC<SelectMessageBublesProps> = ({
    message,
    handleSelect: handleSelectProp,
    updateSelect: updateSelectProp,
    isProcessing = false,
    isEditMode = false,
    alertMessage,
    isBlending = false,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [pendingOption, setPendingOption] = useState<IQuestionOption | null>(null);

    const hasAnswer = message.response?.answer && message.response.answer.length > 0;

    const handleSelect = (option: IQuestionOption) => {
        if (hasAnswer && !isEditMode) {
            setPendingOption(option);
            setShowModal(true);
        } else if (hasAnswer && isEditMode) {
            updateSelectProp(message.question!.questionId, option);
        } else {
            handleSelectProp(message.question!.questionId, option);
        }
    };

    const handleConfirm = () => {
        if (pendingOption) {
            updateSelectProp(message.question!.questionId, pendingOption);
        }
        setShowModal(false);
        setPendingOption(null);
    };

    const handleCancel = () => {
        setShowModal(false);
        setPendingOption(null);
    };

    const oldAnswerText = message.response?.answer?.[0]?.optionText || '';
    const newAnswerText = pendingOption?.optionText || '';

    return (
        <div className='max-w-[90%]'>
            <ChatMessage message={message} />
            {alertMessage && (
                <AlertMessageBubble
                    message={{
                        id: 'profile_colour_alert',
                        type: 'alert',
                        alertVariant: 'info',
                        alertTitle: 'Profile Colour Availability',
                        message: alertMessage,
                        question: {} as any,
                        response: { answer: [], selectedOptionsIds: [], form: {} },
                    }}
                />
            )}
            <SingleChoiceCard
                options={message.question!.options || []}
                selectedId={message.response?.selectedOptionsIds?.[message.response.selectedOptionsIds.length - 1] ?? ""}
                onSelect={handleSelect}
                isDisabled={isProcessing}
                isBlending={isBlending}
            />
            <ConfirmUpdateModal
                visible={showModal}
                questionText={message.question!.question}
                oldAnswer={oldAnswerText}
                newAnswer={newAnswerText}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </div>
    );
}
